import { t } from '../lib/i18n';

// Simple hook that returns our translation function
export function useTranslation() {
  return { t };
} 